import { api } from './api';
export const transactionsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // 购买资产
        purchaseAsset: builder.mutation({
            query: (data) => ({
                url: '/transactions/purchase',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Asset', 'Transactions'],
        }),
        // 获取交易历史
        getTransactions: builder.query({
            query: () => '/transactions',
            providesTags: ['Transactions'],
        }),
        // 获取单个交易详情
        getTransaction: builder.query({
            query: (id) => `/transactions/${id}`,
            providesTags: (result, error, id) => [{ type: 'Transactions', id }],
        }),
        // 申请退款
        requestRefund: builder.mutation({
            query: (transactionId) => ({
                url: `/transactions/${transactionId}/refund`,
                method: 'POST',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Transactions', id }],
        }),
    }),
});
export const { usePurchaseAssetMutation, useGetTransactionsQuery, useGetTransactionQuery, useRequestRefundMutation, } = transactionsApi;
